import { createVNode as o, mergeProps as i } from "vue";
import p from "../node_modules/@pf-ui/pf-icon-svg/es/asn/HelpFilled.js";
import m from "../components/PfIcon.js";
const e = (r, l) => {
  const t = {
    ...r,
    ...l.attrs
  };
  return o(m, i(t, {
    icon: p
  }), null);
};
e.displayName = "HelpFilled";
e.inheritAttrs = !1;
export {
  e as default
};
